import Vue from 'vue'
import Vuex from 'vuex'
import { setCookie, getCookie} from '@/utils/cookie'

Vue.use(Vuex);

const store = new Vuex.Store({
  state:{
    orderInfo:{},
    addressId:null,//收花地址id
    preData:{},//结算商品信息
    tsForm: null,
    addressObj:{} || getCookie('addressObj'),
    goodsInfo: {} || getCookie('goodsInfo'),
    checkExtraList: [],//选择的换购
    
  },
  mutations: {
    updateForm(state,data){
      state.tsForm = data;
    },
    updateAddress(state,data){
      state.addressObj = data;
      setCookie('addressObj', data)
    },
    SET_GOODSINFO(state,goodsInfo){
      state.goodsInfo = goodsInfo;
      setCookie('goodsInfo', goodsInfo)
    },
    SET_CHECKEXTRALIST(state,checkExtraList){
      state.checkExtraList = checkExtraList;
    }
  },
  actions: {
    
  },
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js